import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  value: number; // 0 to 100
  max?: number;
  height?: number;
  color?: string;
  showLabel?: boolean;
  className?: string;
}
export function ProgressBar({
  value,
  max = 100,
  height = 8,
  color = 'bg-indigo-600',
  showLabel = false,
  className = ''
}: ProgressBarProps) {
  const percentage = Math.min(100, Math.max(0, value / max * 100));
  return <div className={`w-full ${className}`} data-id="element-1676">
      {showLabel && <div className="flex justify-between text-xs font-medium text-slate-500 mb-1" data-id="element-1677">
          <span data-id="element-1678">Voortgang</span>
          <span data-id="element-1679">{Math.round(percentage)}%</span>
        </div>}
      <div className="w-full bg-slate-100 rounded-full overflow-hidden" style={{
      height
    }} data-id="element-1680">
        <motion.div className={`h-full rounded-full ${color}`} initial={{
        width: 0
      }} animate={{
        width: `${percentage}%`
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-1681" />
      </div>
    </div>;
}
interface ProgressRingProps {
  progress: number; // 0 to 100
  size?: number;
  strokeWidth?: number;
  color?: string;
  showLabel?: boolean;
  className?: string;
}
export function ProgressRing({
  progress,
  size = 60,
  strokeWidth = 6,
  color = 'text-indigo-600',
  showLabel = true,
  className = ''
}: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - progress / 100 * circumference;
  return <div className={`relative flex items-center justify-center ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-1682">
      <svg className="transform -rotate-90" width={size} height={size} data-id="element-1683">
        <circle className="text-slate-100" strokeWidth={strokeWidth} stroke="currentColor" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-1684" />
        <motion.circle className={color} strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={circumference} animate={{
        strokeDashoffset: offset
      }} transition={{
        type: 'spring',
        stiffness: 50,
        damping: 20,
        duration: 1.5
      }} strokeLinecap="round" stroke="currentColor" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-1685" />
      </svg>
      {showLabel && <motion.div initial={{
      opacity: 0,
      scale: 0
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.5,
      type: 'spring'
    }} className="absolute text-xs font-bold text-slate-700" data-id="element-1686">
          {Math.round(progress)}%
        </motion.div>}
    </div>;
}